import InvoiceService from "@/store/services/invoice.service.js"
import DocumentService from "@/store/services/document.service";

export default {
  data () {
    return {
    }
  },
  computed:{

  },
  methods: {
    getUrl (url, item_id = null) {
      let target_url = null
      if (item_id) {
        target_url = window.Urls[url](item_id)
      } else {
        target_url = window.Urls[url]()
      }
      return target_url
    },
    markAsSent () {
      console.log('markAsSent -> mark as sent invoice')
      this.showAdjustModal = true
      this.markedAsSent = true
    },
    creditInvoice (invoice_id) {
      InvoiceService.createCredit(invoice_id).then((response) => {
        this.$router.push({ name: 'InvoiceEdit', params: { invoiceId: response.data.id } })
      })
    },
    // downloadDocument (item) {
    //   location.href = window.Urls['document-download'](item.id)
    // },
    downloadDocument(item) {
      DocumentService.getDocumentBlob(item.id).then(response => {
        this.promptDownload(response)
      }).catch(error => console.error('Error downloading Document:', error));
    },
    promptDownload (response) {
      const contentDisposition = response.headers['content-disposition'];
      const filename = this.getDownloadFilename(contentDisposition)
      const url = window.URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = url;
      a.download = filename; // Set the filename
      document.body.appendChild(a)
      a.click(); // Trigger download
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url) // Clean up
    },
    getDownloadFilename (contentDisposition) {
      let filename = 'download'; // Default filename
      if (contentDisposition) {
        console.log(contentDisposition)
        const match = contentDisposition.match(/filename="?([^";]+)"?/);
        if (match && match[1]) {
          filename = match[1]; // Extract the actual filename
        }
      }
      return filename
    },
  }
}